import Axios from "axios";
import { AUTH_CREDENTIALS_NAME, APIURL } from "./../Constantes";

const getCabecera = () => {
  let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
  let cabecera = {
    Authorization: `bearer ${Token}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  return cabecera;
};

const urlDuck = "Fligth";

const dataInicial = {
  array: [],
  exito: 0,
  objeto: {},
};

const GET_VUELOS_ALL = "GET_VUELOS_ALL";
const GET_VUELOS_BY_PAQUETE = "GET_VUELOS_BY_PAQUETE";
const GET_VUELOS_CLEAR_STATE = "GET_VUELOS_CLEAR_STATE";
const POST_VUELOS_CATALOG = "POST_VUELOS_CATALOG";
const DELETE_VUELOS_BY_PAQUETE = "DELETE_VUELOS_BY_PAQUETE";

export default function vuelosReducer(state = dataInicial, action) {
  switch (action.type) {
    case DELETE_VUELOS_BY_PAQUETE:
      return { ...state, exito: action.payload.exito };
    case POST_VUELOS_CATALOG:
      return { ...state, exito: action.payload.exito };
    case GET_VUELOS_ALL:
      return { ...state, array: action.payload.array };
    case GET_VUELOS_BY_PAQUETE:
      return { ...state, array: action.payload.array };
    case GET_VUELOS_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
        objeto: action.payload.objeto,
      };
    default:
      return state;
  }
}
export const eliminarVueloPaqueteAction = ({idPaquete, idVuelo, ClaveProveedor, ClavePaquete}) => async (dispatch) => {
  try {
    const respuestaPost = await Axios.delete(
      `${APIURL}/${urlDuck}/Package/${idPaquete}/${idVuelo}/${ClaveProveedor}/${ClavePaquete}`,
      {
        headers: getCabecera(),
      }
    );
    dispatch({
      type: DELETE_VUELOS_BY_PAQUETE,
      payload: {
        exito: 1,
      },
    });
    return respuestaPost;
  } catch (error) {
    return error;
  }
};
export const altaVueloCatalogoAction = (payload) => async (dispatch) => {
  try {
    const respuestaPost = await Axios.post(
      `${APIURL}/${urlDuck}/Add`,
      payload,
      {
        headers: getCabecera(),
      }
    );
    dispatch({
      type: POST_VUELOS_CATALOG,
      payload: {
        exito: 1,
      },
    });
    return respuestaPost;
  } catch (error) {
    return error;
  }
};
export const obtenerVuelosByIdPaqueteAction =
  (IdPaquete) => async (dispatch) => {
    try {
      const respuesta = await Axios.get(
        `${APIURL}/${urlDuck}/Package/${IdPaquete}`,
        {
          headers: getCabecera(),
        }
      );
      dispatch({
        type: GET_VUELOS_BY_PAQUETE,
        payload: {
          array: respuesta.data,
        },
      });
      return respuesta;
    } catch (error) {
      return error;
    }
  };

export const clearVuelosState = () => async (dispatch) => {
  dispatch({
    type: GET_VUELOS_CLEAR_STATE,
    payload: {
      array: [],
      exito: 0,
      objeto: {},
    },
  });
};
